import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/hillsideRetainingWall/blog-hillside-retaining-banner.jpeg";
import img001 from "../../images/hillsideRetainingWall/blog-hillside-retaining-001.jpg";
import img002 from "../../images/hillsideRetainingWall/blog-hillside-retaining-002.jpg";
import img003 from "../../images/hillsideRetainingWall/blog-hillside-retaining-003.jpg";
import img004 from "../../images/hillsideRetainingWall/blog-hillside-retaining-004.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const HillsideRetainingWallData = {
  title:
    "Constructing Hillside Retaining Walls in Los Angeles: What Every Homeowner Needs to Know",
  image: banner,
  destination:
    "/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know",
  date: "September 22, 2016",
  categories: ["blog", "contractors", "retaining-walls"],
};

const HillsideRetainingWall = () => {
  const blog = [HillsideRetainingWallData];

  return (
    <>
      <SEO
        title="Constructing Hillside Retaining Walls: What You Need to Know"
        description="Considering adding hillside retaining walls for your Los Angeles or Southern California property? Learn the top things to consider!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know",
          headline:
            "Constructing Hillside Retaining Walls: What You Need to Know",
          description:
            "Considering adding hillside retaining walls for your Los Angeles or Southern California property? Learn the top things to consider!",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-hillside-retaining-banner.9fdb7e31.jpeg",
          },
          datePublished: "2016-09-22",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Whether you’re a SoCal local or one of the millions of tourists
              that spend time in Los Angeles, there will come a time where you
              will marvel at how home builders laugh in the face of
              topographical challenges. If it’s a prime spot for real estate,
              there’s a home going there, regardless of the terrain.
              <br />
              <br />
              This challenge is one of the reasons Southern California
              properties can be so uniquely beautiful. Slopes add to the charm,
              but they can also present significant difficulty in using as much
              space as you can on a small lot. This challenge often leads to
              retaining wall construction.
            </p>
            <h4>Los Angeles Rules for Retaining Wall Construction</h4>
            <p>
              With one simple online investigative search on the topic of
              building retaining walls in Los Angeles, you will quickly realize
              that there are a lot of rules about building retaining walls on
              Southern California properties.
              <br />
              <br />
              Reading through municipal documents can be dizzying and it will be
              evident that you need a retaining wall contractor for your Los
              Angeles property’s grade challenges.
              <br />
              <br />
              Anytime there needs to be a wall constructed that is over 4 ft.
              tall (including the blocks below the surface), you will need a
              permit for a retaining wall. Large wall projects will need to
              involve an engineer to make sure the proper measures are being
              taken to meet codes.
            </p>
            <h4>
              Cost Impacting Challenges of Retaining Wall Construction in Los
              Angeles
            </h4>
            <p>
              Space is often limited. Many Southern California property owners
              want to spread out with flat surfaces as far as they can around
              their home, using every precious square foot. The seemingly easy
              solution of adding retaining walls and filling the areas in, is
              not a simple solution as many hope.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img001} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <h4>Retaining Wall Height & Length</h4>
                <p>
                  The cost of retaining wall construction in Los Angeles can
                  vary drastically. A wall can cost only $5000 or it can cost
                  you over $50,000 in some cases. This often leads property
                  owners to look for alternatives to deal with slopes in yards.
                  <br />
                  <br />
                  One slight variation could lower retaining wall cost for Los
                  Angeles properties. In some cases, the height of walls may not
                  need to be as high as one would suspect if walls are added,
                  even designed in tiered levels or with the additions of sloped
                  landscape beds placed beside them.
                </p>
              </div>
            </div>

            <h4>Here Are Some Ballpark Prices For Retaining Walls*:</h4>
            <ul>
              <li>
                Small 20 foot segmental wall – stone wall 18 inches tall – best
                to no so good condition – $2,200-$2,700
              </li>
              <li>
                20 ‘ 6 foot fence wall not retaining – $4,300-$4800 (w/ sand
                stucco finish, no cap)
              </li>
              <li>
                20’ 3’ retaining level dirt – $3,200-$3,700 (w/ sand stucco
                finish, no cap)
              </li>
              <li>
                20’ 3 retaining 2 to 1 slope – $3,500-$4,000 (w/ sand stucco
                finish, no cap)
              </li>
              <li>
                20 8’ retaining 2 to 1 – $6,500-$7,000 (w/ sand stucco finish,
                no cap)
              </li>
            </ul>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img002} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <h4>Limited Horizontal Space</h4>
                <p>
                  However, space is still very limited. Spreading out enough may
                  mean you end up on your neighbor’s property or into the
                  street, a situation municipalities won’t allow.
                </p>
              </div>
            </div>
            <p>
              Property owners commonly don’t understand what needs to happen
              underneath the surface of a retaining wall. In order to properly
              anchor a retaining wall and give it the proper footing, more
              native soil has to be disturbed than you may anticipate.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img003} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <h4>Access Difficulties</h4>
                <p>
                  Some spots are extremely hard to get to. In order to be the
                  most cost-effective, wall footings need excavated with
                  equipment. These pieces of machinery will also need room to
                  turn around and places to dump piles of debris and base
                  material. The poorer the access, the more retaining wall cost
                  could go up for your Los Angeles property.
                </p>
              </div>
            </div>
            <p>
              Likewise, steep slopes to the work area will drive up costs or
              make a retaining wall project impossible to execute. It won’t
              matter that there is plenty of room in the backyard if there is an
              unsafe slope to traverse on the way there.
            </p>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img004} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <h4>Existing Soil Structure</h4>
                <p>
                  If only we had X-ray vision. Unfortunately conditions could
                  become very rocky once excavation is begun. Large boulders may
                  require larger equipment or even explosive blasting to remove.
                  Soil problems like these could cause your project costs to
                  rise or even not allow it to be performed.
                </p>
              </div>
            </div>

            <h4>Materials for Los Angeles Retaining Walls</h4>
            <p>
              The overwhelming majority of retaining walls we install in
              Southern California are smaller walls made from manufactured
              concrete blocks. There are 2 primary applications:
            </p>

            <h4>Masonry Retaining Walls</h4>
            <p>
              Some projects use concrete blocks much like a mason uses for the
              foundation of homes. These materials are laid in a similar fashion
              with rebar supports added for additional supports.
              <br />
              <br />
              These walls then are most often covered with stone veneer to match
              existing architecture of homes or other elements of the landscape
              design.
            </p>

            <h4>Interlocking Concrete Block Retaining Walls</h4>
            <p>
              Manufacturers of paving stones also make wall blocks that match
              very nicely with their products or can be used on other areas of
              your property. These types of walls typically are the most
              cost-effective of retaining wall options you will find and are
              extremely durable if installed properly.
              <br />
              <br />
              These walls are topped with cap stone that is glued fast for a
              slight overhang.
            </p>

            <h4>Frequently Overlooked Items</h4>
            <p>
              Be careful that you are using a retaining wall company in Los
              Angeles that has installed walls for many years and knows the best
              practices. If walls are improperly installed, it can cause many
              problems that will show up years down the line.
              <br />
              <br />
              The soil behind walls will retain water. There needs to be a plan
              to move that water so it doesn’t force the wall and make it lean
              or fall over. Drainage solutions should be installed in the ground
              around your retaining walls, directing it elsewhere.
              <br />
              <br />
              There are all sorts of crazy things we’ve seen as a result of
              improper installation, even with wall blocks being set upside down
              from the way the manufacturer intended. Some walls lean or aren’t
              level when you back up a good distance and look at them. These are
              all the result of using a landscaper that may not have much
              experience with this type of specialized construction.
            </p>

            <h4>Should Pacific Pavingstone Install Retaining Walls for You?</h4>
            <p>
              Unlike some companies that say they offer retaining wall
              construction services, we don’t get ourselves into situations
              where we will bite off more than we can chew. There are some
              retaining wall companies in Los Angeles that solely specialize in
              installing only walls. In fact, they are gifted at designing and
              installing huge walls, 15-20 ft. and higher! That’s all they do
              and they sure do it quickly. However, your project may require
              other elements that they may not be equally gifted at. Keep that
              in mind.
              <br />
              <br />
              Pacific Pavingstone has installed a lot of retaining walls in the
              Los Angeles area. Most of the walls we install on residential
              properties don’t get to a massive scale. There are a lot of
              creative landscape design solutions that can keep the cost of
              retaining wall construction down on your property. Some of these
              solutions you may not have even thought of, will end up looking
              better than an immense wall, and save you some money in the long
              run.
              <br />
              <br />
              Finding a knowledgeable, and properly-insured retaining wall
              contractor in Los Angeles is very important. Many problems could
              end up coming back on you as the homeowner if you make a poor
              choice. We’d love to talk to you about your project and show you
              why you can trust us with your property.
              <br />
              <br />
              Check out some pictures of{" "}
              <Link to="/gallery">retaining walls</Link> on projects we’ve
              completed.
              <br />
              <br />
              <Link to="/contact-us">
                When you’re ready, you can contact us for a FREE Consultation or
                call us at (818) 275-8613.
              </Link>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(HillsideRetainingWall);
